import { Component, EventEmitter, Injector, Input, Output } from '@angular/core'
import { AppComponentBase } from '@shared/common/app-component-base';
import { QrMenaCategoryDto } from '@shared/service-proxies/service-proxies';
@Component({
    selector: "qrmena-category-item",
    templateUrl: "./category.component.html"
})
export class CategoryItemComponent extends AppComponentBase {

    @Input() category: QrMenaCategoryDto
    @Output() categoryClick: EventEmitter<number>=new EventEmitter<number>()
    constructor(injector: Injector,) {
        super(injector);
        this.category = new QrMenaCategoryDto()
    }

    handelClick() {
        this.categoryClick.emit(this.category.categoryId)
    }
}


// WEBPACK FOOTER //
// ./src/QrMena/components/category-component/category.component.ts